// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  leaveTypes: []
}

export const mutations = {
  SET_LEAVE_TYPES(state, leaveTypes) {
    state.leaveTypes = leaveTypes
  },
  ADD_LEAVE_TYPE(state, leaveType) {
    state.leaveTypes.push(leaveType)
  },
  EDIT_LEAVE_TYPE(state, leaveType) {
    const index = state.leaveTypes.findIndex(
      el => el.leave_type_uuid === leaveType.leave_type_uuid
    )
    if (index !== -1) {
      state.leaveTypes.splice(index, 1, leaveType)
    }
  },
  DELETE_LEAVE_TYPE(state, leaveTypeUuid) {
    const index = state.leaveTypes.findIndex(
      el => el.leave_type_uuid === leaveTypeUuid
    )
    if (index !== -1) state.leaveTypes.splice(index, 1)
  }
}

export const actions = {
  fetchLeaveTypes({ commit }, payload) {
    return ApiService.fetchLeaveTypes(payload)
      .then(res => {
        const leaveTypes = res.data.data
        commit('SET_LEAVE_TYPES', leaveTypes)
      })
      .catch(error => {
        throw error
      })
  },
  addLeaveType({ commit }, payload) {
    return ApiService.addLeaveType(payload)
      .then(res => {
        const leaveType = res.data
        commit('ADD_LEAVE_TYPE', leaveType)
      })
      .catch(error => {
        throw error
      })
  },
  editLeaveType({ commit }, payload) {
    return ApiService.editLeaveType(payload)
      .then(res => {
        const leaveType = res.data
        commit('EDIT_LEAVE_TYPE', leaveType)
      })
      .catch(error => {
        throw error
      })
  },
  deleteLeaveType({ commit }, payload) {
    return ApiService.deleteLeaveType(payload)
      .then(() => {
        commit('DELETE_LEAVE_TYPE', payload.leave_type_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}
